import React from 'react';
import WrappedBase from './WrappedBase';

import SmsSubscriptionTrigger from '../containers/SmsSubscriptionTrigger';

export default class SmsSubscriptionWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <SmsSubscriptionTrigger {...this.props} />
      </WrappedBase>
    );
  }
}
